import { FormattedMessage } from 'react-intl';
import { useEffect } from 'react';
import Button from '@alltrails/shared/denali/components/Button';
import logExploreWithProButtonClicked from '@alltrails/analytics/events/logExploreWithProButtonClicked';
import logProWelcomePageViewed from '@alltrails/analytics/events/logProWelcomePageViewed';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import CustomProvider from 'components/CustomProvider';
import { wrapUrlSafe } from 'utils/language_support_util';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import * as styles from './styles.module.scss';

const {
  FOR_THE_BEST_EXPERIENCE,
  START_EXPLORING_WITH_PRO,
  YOU_RE_AN_OFFICIAL_PRO_SUBSCRIBER,
  WELCOME_TO_OUR_COMMUNITY_OF_OUTDOOR_ENTHUSIASTS_JUST_LIKE_YOU
} = StringConstantsMixin.strings;

type Props = {
  isAuthed: boolean;
};

function ProWelcome({ isAuthed }: Props) {
  const languageRegionCode = useLanguageRegionCode();

  useEffect(() => {
    logProWelcomePageViewed();
  }, []);

  // could be a shared function
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const buttonPath = isAuthed ? '/explore' : '/login';
  const buttonDestination = wrapUrlSafe(`${buttonPath}?ref=pro-welcome`, languageRegionCode);

  return (
    <CustomProvider>
      <div className={styles.proWelcome}>
        <section>
          <div className={styles.welcomeText}>
            <h1 className={styles.heading}>
              <FormattedMessage defaultMessage="Welcome to {pro}." values={{ pro: <span className={styles.welcomeProBadge} /> }} />
            </h1>
            <p className={styles.welcome}>
              {YOU_RE_AN_OFFICIAL_PRO_SUBSCRIBER}
              <br />
              {WELCOME_TO_OUR_COMMUNITY_OF_OUTDOOR_ENTHUSIASTS_JUST_LIKE_YOU}
            </p>
            {isMobile ? (
              <p className={styles.mobile}>{FOR_THE_BEST_EXPERIENCE}</p>
            ) : (
              <Button
                text={START_EXPLORING_WITH_PRO}
                linkInfo={{ href: buttonDestination }}
                onClick={logExploreWithProButtonClicked}
                testId="pro-welcome-start-exploring"
                variant="primary"
              />
            )}
          </div>
          <div className={styles.topImage} />
        </section>
      </div>
    </CustomProvider>
  );
}

export default ProWelcome;
